import axios from "axios";
import { STATUSES } from "./apiStatus";
import { base_url } from "../utils";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const changeAccountType = createAsyncThunk(
  "changeAccountType/fetch",
  async (data, { rejectWithValue, serializeError }) => {
    try {
      const response = await axios.post(
        `${base_url}/digilocker/changeAccountType`,
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  },
  {
    serializeError: (err) => err.message,
  }
);

const changeAccountTypeSlice = createSlice({
  name: "changeAccountType",
  initialState: {
    accountStatusData: {},
    accountStatuses: "idle",
    error: null,
  },
  reducers: {
    clearAccountData: (state) => {
      state.accountStatusData = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(changeAccountType.pending, (state, action) => {
        state.accountStatuses = STATUSES.LOADING;
      })
      .addCase(changeAccountType.fulfilled, (state, action) => {
        state.accountStatusData = action.payload;
        state.accountStatuses = STATUSES.IDLE;
      })
      .addCase(changeAccountType.rejected, (state, action) => {
        state.accountStatuses = STATUSES.ERROR;
      });
  },
});
export const { clearAccountData } = changeAccountTypeSlice.actions;
export default changeAccountTypeSlice.reducer;
